import React, { useRef, Fragment } from "react"
import { connect } from "react-redux"
import { translate } from "react-i18next"
import compose from "ramda/src/compose"
import { Field, reduxForm } from "redux-form"
import * as Yup from "yup"
import { asyncValidate, shouldAsyncValidate } from "redux-form-yup"
import PropTypes from "prop-types"

import FloatLabelInput from "shared/components/ModernFloatLabelInput"
import FloatLabelTextArea from "shared/components/ModernFloatLabelTextArea"
import Loader from "components/Loading"
import Modal from "shared/components/ModernModal"
import Typograph from "components/Typograph"
import ContainerView from "scenes/Customer/components/ContentView"
import DescriptionList from "components/DescriptionList"

import { changeStatus } from "services/state/repair/action"

import styles from "../../styles.css"
import { phone, algarPhone } from "services/utils/mask"

const renderInputField = (field) => {
  const {
    meta: { touched, error, invalid }
  } = field

  return (
    <FloatLabelInput
      {...field.input}
      id={field.id}
      type={field.type}
      label={field.label}
      maxLength={field.maxLength}
      invalid={touched && invalid}
      error={error}
      containerClasses={styles.paddingTop}
    />
  )
}

const renderTextAreaField = (field) => {
  const {
    meta: { touched, error, invalid }
  } = field

  return (
    <FloatLabelTextArea
      {...field.input}
      id={field.id}
      label={field.label}
      preset="modalTextArea"
      invalid={touched && invalid}
      error={error}
      containerClasses={styles.paddingTop}
      noResize
    />
  )
}

const ProblemSolvedModal = ({
  t,
  isOpen,
  onClose,
  demand,
  handleSubmit,
  submitting,
  changeStatus,
  onAnswer
}) => {
  const statusRef = useRef("")
  const formRef = useRef(null)

  const onSubmit = (form) => {
    const { requestId } = demand
    const data = { ...form, requestId, status: statusRef.current }

    return changeStatus(data).then(() => onAnswer())
  }

  const setProblemSolved = (status) => {
    statusRef.current = status
  }

  if (!demand || !demand.protocolNumber) return null

  const { protocolNumber, closeDate, summary } = demand

  return (
    <Fragment>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        onCancel={() => {
          setProblemSolved("Nao_Aceito")
          formRef.current.requestSubmit()
        }}
        onConfirm={() => {
          setProblemSolved("Aceito")
          formRef.current.requestSubmit()
        }}
        cancelButtonText={t("MSG_0199")}
        confirmButtonText={t("MSG_0200")}
      >
        <Typograph
          htmlTag="h4"
          size="medium"
          color="outer_space"
          weight="bold"
          classNames={styles.marginBottom}
        >
          {t("MSG_0291")}
        </Typograph>

        <Typograph htmlTag="h5" size="medium" color="outer_space" weight="bold">
          {t("MSG_0198")}
        </Typograph>

        <ContainerView classNames={styles.noMargin}>
          {protocolNumber && (
            <DescriptionList
              description={`${t("MSG_0249")}:`}
              value={protocolNumber}
              first
              hasDivider
            />
          )}
          {closeDate && (
            <DescriptionList
              description={`${t("MSG_0240")}:`}
              value={closeDate}
              first
              hasDivider
            />
          )}
        </ContainerView>

        <ContainerView className={styles.marginTop}>
          <DescriptionList
            description={`${t("MSG_0371")}:`}
            value={summary}
            direction="col"
            hasDivider={false}
          />
        </ContainerView>

        <form
          ref={formRef}
          className={styles.form}
          onSubmit={handleSubmit(onSubmit)}
          noValidate
        >
          <Field
            id="contactName"
            label="Digite seu nome"
            name="contactName"
            component={renderInputField}
          />
          <Field
            id="contactPhone"
            label={t("MSG_0017")}
            name="contactPhone"
            maxLength={15}
            component={renderInputField}
            format={phone}
            normalize={algarPhone}
          />

          <Field
            label="Faça uma breve descrição"
            name="information"
            component={renderTextAreaField}
          />
        </form>
      </Modal>
      <Loader isOpen={submitting} />
    </Fragment>
  )
}

ProblemSolvedModal.propTypes = {
  t: PropTypes.func,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  demand: PropTypes.object,
  handleSubmit: PropTypes.func,
  submitting: PropTypes.bool,
  changeStatus: PropTypes.func,
  onAnswer: PropTypes.func
}

ProblemSolvedModal.defaultProps = {
  msg: "",
  onClose: false
}

const mapStateToProps = ({ repair }) => ({
  repair
})

function createValidationSchema() {
  return Yup.object().shape({
    contactName: Yup.string().required("Campo obrigatório"),

    contactPhone: Yup.string()
      .required("Campo obrigatório")
      .matches(/^0\d{1,11}$/, {
        message: "Número de telefone inválido",
        excludeEmptyString: true
      }),

    information: Yup.string().required("Campo obrigatório")
  })
}

const reduxFormConfig = {
  form: "ProblemSolvedForm",
  asyncValidate: asyncValidate(createValidationSchema()),
  shouldAsyncValidate
}

const enhance = compose(
  translate(),
  connect(mapStateToProps, { changeStatus }),
  reduxForm(reduxFormConfig)
)

export default enhance(ProblemSolvedModal)



// WEBPACK FOOTER //
// ./src/scenes/IncidentManager/components/ProblemSolvedModal/index.js